var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"loading"},[(!_vm.show)?_c('span',[_vm._t("default")],2):_c('b-spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }